import { useState } from 'react'

import { Button, useConfirmationDialog } from '@factorialco/deprecated-design-system'
import {
  CompetenciesDataTableDocument,
  CompetenciesDataTableQuery,
} from 'generated/resources/datatable.graphql'
import { CompetenciesBulkDeleteCompetenciesDocument } from 'generated/resources/graphql'

import { useDataTable } from 'modules/core/components/DataTable'
import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useMutation } from 'modules/core/hooks/useMutation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { AddToGroupModal } from './AddToGroupModal'

export const TableBulkActions = () => {
  const [showAddToGroupDialog, setShowAddToGroupDialog] = useState(false)
  const { openDialog } = useConfirmationDialog()
  const dataTable = useDataTable<CompetenciesDataTableQuery>()
  const selectedCompetencies = [...dataTable.selectedRows].map((v) => v.toString())

  const [bulkDeleteCompetenciesCompetency, { loading: deleting }] = useMutation(
    CompetenciesBulkDeleteCompetenciesDocument,
    {
      extractorFn: (data) => data.competenciesMutations.bulkDeleteCompetenciesCompetency,
      refetchQueries: [CompetenciesDataTableDocument],
    }
  )

  const onDelete = async () => {
    const result = await bulkDeleteCompetenciesCompetency({
      variables: { ids: selectedCompetencies.map((id) => id.toString()) },
    })

    const handled = handleResult(result, () => undefined)

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.removed_successfully'),
      })
      track(trackingEvents.competencies.deleteCompetenciesInBulk)
    }

    return handled
  }

  return (
    <>
      {selectedCompetencies.length > 0 && (
        <PopoverMenu type="list">
          <PopoverMenu.Trigger asChild>
            <Button
              type="secondary"
              aria-label={i18n.t('competencies_v3.competencies_table.bulk_actions.more_options')}
              iconName="list"
            >
              {i18n.t('common.actions')}
            </Button>
          </PopoverMenu.Trigger>

          <PopoverMenu.Content side="bottom" align="end">
            <PopoverMenu.TouchableOption
              title={i18n.t('competencies_v3.competencies_table.bulk_actions.add_to_group.title')}
              onClick={() => setShowAddToGroupDialog(true)}
              disabled={selectedCompetencies.length < 1}
            />
            <PopoverMenu.TouchableOption
              title={i18n.t('competencies_v3.competencies_table.bulk_actions.delete.title')}
              onClick={() =>
                openDialog({
                  illustration: 'delete-cross',
                  title: i18n.tp(
                    'competencies_v3.competencies_table.bulk_actions.delete.confirmation_modal.title',
                    { count: selectedCompetencies.length }
                  ),
                  description: i18n.tp(
                    'competencies_v3.competencies_table.bulk_actions.delete.confirmation_modal.description',
                    { count: selectedCompetencies.length }
                  ),
                  onConfirm: onDelete,
                })
              }
              disabled={deleting}
              danger
            />
          </PopoverMenu.Content>
        </PopoverMenu>
      )}
      {showAddToGroupDialog && (
        <AddToGroupModal
          onClose={() => setShowAddToGroupDialog(false)}
          selectedCompetencies={selectedCompetencies}
        />
      )}
    </>
  )
}
